import {
  ScriveWorkflowJobState,
  ScriveWorkflowJobMutationTypes,
  CustomTabDynamicFormUpdateModel,
  FieldUpdateModel,
  ScriveSignersTabModel,
  RootState
} from '@/types';
import { ActionTree } from 'vuex';
import { ScriveSignersTabService } from '@/services/scrive/ScriveSignersTabService';
import store from '../index';
import { ScriveConstants } from '@/types';

export const actions: ActionTree<ScriveWorkflowJobState, RootState> = {
  getSignersTab(this: any, { commit }: any, jobId: number) {
    commit(ScriveWorkflowJobMutationTypes.SetIsSignersTabLoading, true);
    ScriveSignersTabService.getScriveSignersTabAsync(jobId)
      .then((response: ScriveSignersTabModel) => {
        commit(ScriveWorkflowJobMutationTypes.SignersTabLoaded, response);
        store.dispatch('workflowJobStore/addCustomFormsDynamicFormValidationModel', response.dynamicForm.formId);
        store.dispatch('workflowJobStore/addDynamicFormModelToCustomJobTab', {
          key: ScriveConstants.CustomSignersTabKey,
          dynamicForm: response.dynamicForm
        } as CustomTabDynamicFormUpdateModel);
      })
      .catch((error: any) => {
        commit(ScriveWorkflowJobMutationTypes.SignersTabError, error);
      });
  },
  setSignersTabFieldValue(this: any, { commit }, fieldUpdateModel: FieldUpdateModel) {
    store.dispatch('workflowJobStore/setIsDirty', true);
    commit(ScriveWorkflowJobMutationTypes.UpdateSignersDataSourceFieldValue, fieldUpdateModel);
  },
  unloadScriveWorkflowJob({ commit }) {
    commit(ScriveWorkflowJobMutationTypes.UnloadSignersWorkflowJob);
  }
};
